import Hero from './components/Hero';
import CommunityImpact from './components/CommunityImpact';
import CommunityReach from './components/CommunityReach';
import FeaturedSponsorship from './components/FeaturedSponsorship';
import SponsorshipLevels from './components/SponsorshipLevels';
import CommunitySupporters from './components/CommunitySupporters';
import SponsorshipFunds from './components/SponsorshipFunds';
import SocialProof from './components/SocialProof';
import SponsorReviews from './components/SponsorReviews';
import PhotoGallery from './components/PhotoGallery';
import LimitedAvailability from './components/LimitedAvailability';
import SponsorshipForm from './components/SponsorshipForm';
import FinalCTA from './components/FinalCTA';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  const scrollToForm = () => {
    const formElement = document.getElementById('sponsorship-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Hero onCTAClick={scrollToForm} />
      <CommunityImpact />
      <CommunityReach />
      <FeaturedSponsorship onCTAClick={scrollToForm} />
      <SponsorshipLevels onCTAClick={scrollToForm} />
      <CommunitySupporters />
      <SponsorshipFunds />
      <SocialProof />
      <SponsorReviews />
      <PhotoGallery />
      <LimitedAvailability />
      <SponsorshipForm />
      <FinalCTA onCTAClick={scrollToForm} />
    </div>
  );
}
